const CurrentRedemptionAction = require('@/lib/Memberships/CurrentRedemptionAction');
const MembershipCardAllocationType = require('@/lib/Memberships/MembershipCardAllocationType');
const { invalidateOrderSearchCache } = require('@/lib/Orders/orderSearchCacheFuncs');

/**
 * This is still used in the MembershipDatasetsModal.
 *
 * @param $timeout
 * @param {ToastFactory} toastFactory
 * @param {UserService} userService
 */
const memberTileDirective = function (
    $timeout,
    toastFactory,
    userService
) {
    return {
        restrict: 'E',
        scope: {
            editMemberFunc: '=',
            index: '=',
            member: '=',
            membership: '=',
            membershipSubscription: '=',
            selectedMember: '=',
            showMembershipRef: '=',
            toggleVisitFunc: '=',
        },
        templateUrl: 'partials/directives/dt-member-tile.html',
        controller: function controller($scope) {
            /**
             * Determine if the contact ref should be shown on the title.
             * This is an array of card allocation types that should cause the ref to be shown.
             *
             * @type {string[]}
             */
            let showMemberRefsFor = [
                MembershipCardAllocationType.ADULTS,
                MembershipCardAllocationType.MEMBER,
            ];
            $scope.showMemberRef = showMemberRefsFor.indexOf(userService.company.membershipCardAllocation) !== -1;
            if ($scope.showMembershipRef) {
                $scope.showMemberRef = true;
            }

            /**
             * When the edit button is clicked on the tile fire the passed in edit function.
             *
             * @param {Event} $event
             * @param member
             * @param index
             */
            $scope.editTileMember = function ($event, member, index) {
                if (typeof $scope.editMemberFunc === 'function') {
                    $scope.editMemberFunc(member, index);
                }
            };

            /**
             * When the redeem/un-redeem button is clicked on the title fire the passed in redeem function.
             *
             * @param member
             */
            $scope.toggleTileMemberVisit = function (member) {
                if (member.currentRedemptionAction !== CurrentRedemptionAction.NONE) {
                    return;
                }
                if (typeof $scope.toggleVisitFunc === 'function') {
                    $scope.toggleVisitFunc(
                        member,
                        $scope.membershipSubscription,
                        $scope.membershipSubscription.membershipPlan,
                        $scope.membership
                    );

                    invalidateOrderSearchCache();
                }
            };

            /**
             * Save the member.
             *
             * @param {Event} $event
             * @param {Member} member
             */
            $scope.saveMember = async function ($event, member) {
                member.saving = true;
                $event.stopPropagation();

                // Just add a tiny delay and show a spinner so the transition feels better.
                $timeout(() => {
                    member.saving = false;

                    if (!member.contact.firstName || !member.contact.lastName) {
                        toastFactory.warningTop('MEMBERSHIP_VALIDATION.NO_FIRST_LAST_NAME');
                        return;
                    }
                    member.saved = true;
                }, 500);
            };
        },
    };
};

module.exports = memberTileDirective;
